import React from "react"
import { useSelector } from "react-redux"

import { StoreType } from "client/store"
import {
    TableWrapper,
    TableScroller,
    TableContentWrapper,
    TableRow,
    TableHeaderCell,
    TableCell,
    TableCellContentWrapper,
    TableCellContent,
} from "client/components"

import Columns from "./columns"

const CurrentPackage = () => {
    const activePackage = useSelector((state: StoreType) => state.system.packageActive)

    const columns = Columns()
    return (
        <TableWrapper>
            <TableScroller>
                <TableContentWrapper>
                    <thead>
                        <TableRow size="sm" noHover>
                            {
                                columns.map((column) => (
                                    <TableHeaderCell
                                        key={column.field}
                                        cellMinWidth={column.cellMinWidth || null}
                                    >
                                        {
                                            column.header
                                            && <span>{column.header}</span>
                                        }
                                    </TableHeaderCell>
                                ))
                            }
                        </TableRow>
                    </thead>
                    <tbody>
                        <TableRow size="sm">
                            {
                                columns.map((column) => (
                                    <TableCell
                                        key={column.field}
                                        cellMinWidth={column.cellMinWidth || null}
                                    >
                                        <TableCellContentWrapper>
                                            <TableCellContent>
                                                {column.formatter(activePackage)}
                                            </TableCellContent>
                                        </TableCellContentWrapper>
                                    </TableCell>
                                ))
                            }
                        </TableRow>
                    </tbody>
                </TableContentWrapper>
            </TableScroller>
        </TableWrapper>
    )
}
export default CurrentPackage
